import { GetDataForAccommodationsThanksForRSVPQuery, AccommodationPlaceRoomBlockStatus } from '@graphql/generated';

export type AccommodationPlacesV2 = NonNullable<NonNullable<GetDataForAccommodationsThanksForRSVPQuery['eventByName']>['accommodationPlacesV2'][number]>;

export type HotelRoomBlocks = NonNullable<NonNullable<GetDataForAccommodationsThanksForRSVPQuery['eventByName']>['hotelRoomBlocks']>;

export enum AccommodationCombinedType {
  Roomblock = 'Roomblock',
  Hotel = 'Hotel',
  Custom = 'Custom',
}
export interface AccommodationCombined {
  id: string;
  type: AccommodationCombinedType;

  //   General Information
  displayName?: Maybe<string>;
  latitude?: Maybe<number>;
  longitude?: Maybe<number>;

  //   Extra Information
  bookingUrl?: Maybe<string>;
  cutoffDate?: Maybe<string>;

  //   Custom Properties
  isFavorite?: Maybe<boolean>;

  photo: Maybe<{
    id?: Maybe<string>;
    url?: Maybe<string>;
  }>;

  status?: Maybe<AccommodationPlaceRoomBlockStatus>;
}
